/**
 * Utility functions for Facebook / Meta Pixel tracking.
 */

/**
 * Dynamically loads and initializes the Meta Pixel script.
 * @param {string} pixelId - The Meta Pixel ID
 */
export const initPixel = (pixelId) => {
  if (!pixelId) {
    console.warn("Meta Pixel ID is missing. Tracking is disabled.");
    return;
  }

  if (window.fbq) return;

  /* eslint-disable no-unused-expressions */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );
  /* eslint-enable no-unused-expressions */

  window.fbq("init", pixelId);
};

/**
 * Tracks a standard PageView event.
 */
export const trackPageView = () => {
  if (window.fbq) {
    window.fbq("track", "PageView");
  }
};

/**
 * Tracks a standard event with optional parameters.
 * @param {string} eventName - Standard event name (e.g. 'InitiateCheckout', 'Purchase')
 * @param {Object} data - Parameters for the event
 */
export const trackEvent = (eventName, data) => {
  if (window.fbq) {
    if (data !== undefined) {
      window.fbq("track", eventName, data);
    } else {
      window.fbq("track", eventName);
    }
  }
};

/**
 * Tracks a custom event with optional parameters.
 * @param {string} eventName - Name of the custom event
 * @param {Object} data - Parameters for the event
 */
export const trackCustomEvent = (eventName, data) => {
  if (window.fbq) {
    if (data !== undefined) {
      window.fbq("trackCustom", eventName, data);
    } else {
      window.fbq("trackCustom", eventName);
    }
  }
};
